import qrcode from "qrcode";
export default {
  name: "downLoad-item",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    initQrcode() {
      qrcode.toCanvas(this.$refs.qrcodeRef, this.item.link, {
        width: 120,
        height: 120
      });
    }
  },
  mounted() {
    this.initQrcode();
  }
};